import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Send, X } from "lucide-react";
import { api } from "@/lib/leuteliaApi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const EMPTY = { nome: "", hotel: "", citta: "", email: "", telefono: "", messaggio: "" };

export function RichiestaForm({ onDone }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.demoRichiesta(f); setSent(true); onDone?.(); }
    catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };
  if (sent) return (
    <div className="text-[14px] text-brand-ink leading-relaxed" data-testid="richiesta-inviata">
      <p className="font-serif text-[22px] text-brand-green">Richiesta ricevuta.</p>
      <p className="mt-2">LEUTELIA ti scriverà entro pochi giorni all'indirizzo indicato. Nessuna analisi viene avviata automaticamente: ogni passo è concordato con te.</p>
    </div>
  );
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="richiesta-form">
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="block text-[12.5px] font-semibold text-brand-ink">Nome e cognome<Input data-testid="richiesta-nome" value={f.nome} onChange={set("nome")} required className="mt-1 h-10" /></label>
        <label className="block text-[12.5px] font-semibold text-brand-ink">Hotel<Input data-testid="richiesta-hotel" value={f.hotel} onChange={set("hotel")} required className="mt-1 h-10" /></label>
        <label className="block text-[12.5px] font-semibold text-brand-ink">Città<Input data-testid="richiesta-citta" value={f.citta} onChange={set("citta")} className="mt-1 h-10" /></label>
        <label className="block text-[12.5px] font-semibold text-brand-ink">Email<Input data-testid="richiesta-email" type="email" value={f.email} onChange={set("email")} required className="mt-1 h-10" /></label>
        <label className="block text-[12.5px] font-semibold text-brand-ink sm:col-span-2">Telefono (facoltativo)<Input data-testid="richiesta-telefono" value={f.telefono} onChange={set("telefono")} className="mt-1 h-10" /></label>
      </div>
      <label className="block text-[12.5px] font-semibold text-brand-ink">Messaggio
        <textarea data-testid="richiesta-messaggio" value={f.messaggio} onChange={set("messaggio")} rows={3} className="mt-1 w-full rounded-md border border-input bg-white px-3 py-2 text-[13.5px]" placeholder="Cosa vorresti capire del tuo hotel?" />
      </label>
      <Button type="submit" disabled={busy} data-testid="richiesta-submit" className="w-full h-11 rounded-lg bg-brand-green hover:bg-brand-greenDark text-brand-cream text-[14px] font-semibold">
        {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : <Send size={16} className="mr-2" />} Invia la richiesta
      </Button>
      <p className="text-[11.5px] text-brand-muted">La richiesta arriva a info@leutelia.it. Nessuna scansione del tuo hotel parte senza accordo.</p>
    </form>
  );
}

export function RichiestaDialog({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const k = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] bg-brand-greenDark/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="richiesta-dialog">
      <div className="w-full max-w-[560px] bg-brand-cream rounded-2xl border border-brand-gold/40 p-6 sm:p-8 leu-in shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-brand-orange font-bold tracking-[0.22em] text-[11px] uppercase">LEUTELIA Experience</div>
            <h2 className="font-serif text-[24px] text-brand-ink leading-tight mt-1">Scopri cosa LEUTELIA può individuare nel tuo hotel</h2>
          </div>
          <button onClick={onClose} aria-label="Chiudi" className="text-brand-muted hover:text-brand-ink" data-testid="richiesta-close"><X size={20} /></button>
        </div>
        <div className="mt-5"><RichiestaForm /></div>
      </div>
    </div>
  );
}
